export function findBiggestName(mapElements) {
  var biggestName = 0;
  mapElements.forEach((element) => {
    if (element.name > biggestName) biggestName = element.name;
  });
  return biggestName;
}
